/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __extends } from "tslib";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as operations from "./operations";
import { LabsApiClientContext } from "./labsApiClientContext";
var LabsApiClient = /** @class */function (_super) {
  __extends(LabsApiClient, _super);
  /**
   * Initializes a new instance of the LabsApiClient class.
   * @param credentials Credentials needed for the client to connect to Azure.
   * @param subscriptionId The ID of the target subscription.
   * @param [options] The parameter options
   */
  function LabsApiClient(credentials, subscriptionId, options) {
    var _this = _super.call(this, credentials, subscriptionId, options) || this;
    _this.coreUsage = new operations.CoreUsageOperations(_this);
    _this.lab = new operations.LabOperations(_this);
    _this.priceAndAvailability = new operations.PriceAndAvailability(_this);
    _this.register = new operations.Register(_this);
    _this.userSettings = new operations.UserSettings(_this);
    _this.virtualMachine = new operations.VirtualMachineOperations(_this);
    _this.prices = new operations.Prices(_this);
    _this.subscriptionPrices = new operations.SubscriptionPrices(_this);
    _this.operationResults = new operations.OperationResults(_this);
    return _this;
  }
  return LabsApiClient;
}(LabsApiClientContext);
// Operation Specifications
export { LabsApiClient, LabsApiClientContext, Models as LabsApiModels, Mappers as LabsApiMappers };
export * from "./operations";